<div class="validation-display-element validation-display-element-error" [ngClass]="classes">
    <div>
        <div class="validation-display-icon fa fa-exclamation-triangle"></div>
        <div class="validation-display-error-text">{{item?.error?.error || item.key}}</div>
    </div>
</div>
